export const getUserID = () => {
    return localStorage.getItem('helpPageUserId');
};

export const saveUserID = (userId) => {
    localStorage.setItem('helpPageUserId', userId);
};